import React, { useState } from "react";
import ReactECharts from "echarts-for-react";
import { IoOpenOutline } from "react-icons/io5";
import ServiceCollabaxModal from "../Modals/ServiceCollabaxModal";

/* ICONS */
import Taas_Revenue from "../../Artifacts/scvpu/zoneDashboard/tassRevenue.svg";
import Accidental_Revenue_Percentage from "../../Artifacts/scvpu/zoneDashboard/accidentRevenue.svg";
import Revenue_Per_Vehicle from "../../Artifacts/scvpu/zoneDashboard/vehicleRevenue.svg";
import serviceRevenuePenetration from "../../Artifacts/scvpu/zoneDashboard/Service_Penetration.svg";
import NPS from "../../Artifacts/scvpu/zoneDashboard/NPS.svg";
import CPTC from "../../Artifacts/scvpu/zoneDashboard/CPTC.svg";
import FSHR from "../../Artifacts/scvpu/zoneDashboard/FSHR.svg";

import Total_Revenue from "../../Artifacts/scvpu/zoneDashboard/tassRevenue.svg";
import Dealer_Revenue from "../../Artifacts/scvpu/zoneDashboard/dealerRevnenue.svg";
import Total_Accidental_Revenue from "../../Artifacts/scvpu/zoneDashboard/accidentRevenue.svg";
import Dealer_Accidental_Revenue from "../../Artifacts/scvpu/zoneDashboard/accidentDealerRevenue.svg";

import TotalJobCard from "../../Artifacts/scvpu/zoneDashboard/TotalJobCard.svg";
import AccidentJobCard from "../../Artifacts/scvpu/zoneDashboard/AccidentJobCard.svg";
import FirstThreeService from "../../Artifacts/scvpu/zoneDashboard/FirstThreeService.svg";

import CPSC_DEALER_SCORE_ABOVE_200 from "../../Artifacts/scvpu/zoneDashboard/cpsc.svg";
import veh_bay from "../../Artifacts/scvpu/zoneDashboard/cpsc.svg";
import dealer_veh_bay from "../../Artifacts/scvpu/zoneDashboard/cpsc.svg";
import taas_veh_bay from "../../Artifacts/scvpu/zoneDashboard/cpsc.svg";

import JOB_CARD from "../../Artifacts/scvpu/zoneDashboard/job_card.svg";
import IPTV_C1 from "../../Artifacts/scvpu/zoneDashboard/iptv_c1.svg";
import IPTV_TOTAL from "../../Artifacts/scvpu/zoneDashboard/iptv_total.svg";
import POST_FEEDBACK from "../../Artifacts/scvpu/zoneDashboard/post service feedback.svg";

import CUSTOMER_EFFORT_SCORE from "../../Artifacts/scvpu/zoneDashboard/customer_effort_score.svg";
import GOLD from "../../Artifacts/scvpu/zoneDashboard/Goldtech.svg";

/* =====================================================
   ICON MAP
===================================================== */

const iconMap = {
  "%_SERVICE_REVENUE_PENETRATION": serviceRevenuePenetration,
  SERVICE_REVENUE_PENETRATION: serviceRevenuePenetration,
  "%_OF_TOTAL_REVENUE_FROM_ACCIDENT_BUSINESS": Total_Accidental_Revenue,
  "%_OF_REVENUE_FROM_TASS": Total_Revenue,
  TASS_REVENUE: Taas_Revenue,
  REVENUE_PER_VEH: Revenue_Per_Vehicle,
  ACCIDENTAL_REVENUE_PERCENTAGE: Accidental_Revenue_Percentage,
  TAAS_REVENUE_PERCENTAGE: Taas_Revenue,

  TOTAL_REVENUE: Total_Revenue,
  DEALER_REVENUE: Dealer_Revenue,
  TOTAL_ACCIDENTAL_REVENUE: Total_Accidental_Revenue,
  DEALER_ACCIDENTAL_REVENUE: Dealer_Accidental_Revenue,
  TAAS_ACCIDENTAL_REVENUE: Taas_Revenue,
  TASS_ACCIDENTAL_REVENUE: Taas_Revenue,

  TOTAL_JOB_CARD: TotalJobCard,
  TAAS_JOB_CARD: TotalJobCard,
  TASS_JOB_CARD: TotalJobCard,
  DEALER_JOB_CARD: TotalJobCard,

  TOTAL_ACCIDENTAL_JOB_CARD: AccidentJobCard,
  TAAS_ACCIDENTAL_JOB_CARD: AccidentJobCard,
  TASS_ACCIDENTAL_JOB_CARD: AccidentJobCard,
  DEALER_ACCIDENTAL_JOB_CARD: AccidentJobCard,

  TOTAL_FIRST_THREE_SERVICE_JOB_CARD: FirstThreeService,
  TASS_FIRST_THREE_SERVICE_JOB_CARD: FirstThreeService,
  DEALER_FIRST_THREE_SERVICE_JOB_CARD: FirstThreeService,

  "%_CPSC_(DEALER SCORE ABOVE 200)": CPSC_DEALER_SCORE_ABOVE_200,
  "VEH/_BAY/_DAY": veh_bay,
  "DEALER/_VEH/_BAY/_DAY": dealer_veh_bay,
  "TASS/_VEH/_BAY/_DAY": taas_veh_bay,

  TOTAL_OPEN_JOB_CARD: JOB_CARD,
  DEALER_OPEN_JOB_CARD: JOB_CARD,

  TASS_OPEN_JOB_CARD: JOB_CARD,

  SERVICE_CHARTER_IPTV_C1: IPTV_C1,
  SERVICE_CHARTER_IPTV_TOTAL: IPTV_TOTAL,
  "GOLD_TECH_%": GOLD,
  "%_POST_SERVICE_FEEDBACK": POST_FEEDBACK,
  CUSTOMER_EFFORT_SCORE: CUSTOMER_EFFORT_SCORE,
  "%_NPS": NPS,
  CPTC: CPTC,
  "%_FSHR": FSHR,
  REVENUE_PER_VEHICLE: Revenue_Per_Vehicle,
  "CPSC (Dealer Score Above 200)": CPSC_DEALER_SCORE_ABOVE_200,
  CPSC: CPSC_DEALER_SCORE_ABOVE_200,
  TOTAL_ACCIDENT_REVENUE: Total_Accidental_Revenue,
};

/* =====================================================
   🔹 PARAM MAP (MOST IMPORTANT PART)
===================================================== */

const chartParamMap = {
  TAAS_REVENUE: {
    Partner_Type: ["TASS"],
  },
  TASS_REVENUE: {
    Partner_Type: ["TASS"],
  },
  TOTAL_REVENUE: {
    Partner_Type: [],
    Service_Type: [],
  },
  DEALER_REVENUE: {
    Partner_Type: ["Dealer"],
    Service_Type: [],
  },
  TOTAL_ACCIDENTAL_REVENUE: {
    Partner_Type: [],
    Service_Type: ["Accident"],
  },
  DEALER_ACCIDENTAL_REVENUE: {
    Partner_Type: ["Dealer"],
    Service_Type: ["Accident"],
  },
  TAAS_ACCIDENTAL_REVENUE: {
    Partner_Type: ["TASS"],
    Service_Type: ["Accident"],
  },
  TASS_ACCIDENTAL_REVENUE: {
    Partner_Type: ["TASS"],
    Service_Type: ["Accident"],
  },
  TAAS_REVENUE_PERCENTAGE: {
    Partner_Type: ["TASS"],
  },
  ACCIDENTAL_REVENUE_PERCENTAGE: {
    Service_Type: ["Accident"],
  },

  // Profitability

  TOTAL_JOB_CARD: {
    Partner_Type: [],
    Service_Type: [],
  },
  DEALER_JOB_CARD: {
    Partner_Type: ["Dealer"],
    Service_Type: [],
  },
  TAAS_JOB_CARD: {
    Partner_Type: ["TASS"],
    Service_Type: [],
  },
  TASS_JOB_CARD: {
    Partner_Type: ["TASS"],
    Service_Type: [],
  },
  TOTAL_ACCIDENTAL_JOB_CARD: {
    Partner_Type: [],
    Service_Type: ["Accident"],
  },
  DEALER_ACCIDENTAL_JOB_CARD: {
    Partner_Type: ["Dealer"],
    Service_Type: ["Accident"],
  },
  TAAS_ACCIDENTAL_JOB_CARD: {
    Partner_Type: ["TASS"],
    Service_Type: ["Accident"],
  },
  TASS_ACCIDENTAL_JOB_CARD: {
    Partner_Type: ["TASS"],
    Service_Type: ["Accident"],
  },
  TOTAL_FIRST_THREE_SERVICE_JOB_CARD: {
    Partner_Type: [],
    Service_Type: [
      "First Free Service",
      "Second Free Service",
      "Third Free Service",
    ],
  },
  DEALER_FIRST_THREE_SERVICE_JOB_CARD: {
    Partner_Type: ["Dealer"],
    Service_Type: [
      "First Free Service",
      "Second Free Service",
      "Third Free Service",
    ],
  },
  TAAS_FIRST_THREE_SERVICE_JOB_CARD: {
    Partner_Type: ["TASS"],
    Service_Type: [
      "First Free Service",
      "Second Free Service",
      "Third Free Service",
    ],
  },
  TASS_FIRST_THREE_SERVICE_JOB_CARD: {
    Partner_Type: ["TASS"],
    Service_Type: [
      "First Free Service",
      "Second Free Service",
      "Third Free Service",
    ],
  },
};

/* =====================================================
   COMPONENT
===================================================== */
let colorPointer = 0;
export default function AreaChart({
  title,
  data,
  target,
  previousYear,
  ytdActual,
  modalEndpoint,
  modalPayload = {},
}) {
  // Remove underscores from title

  const [isModalOpen, setIsModalOpen] = useState(false);
  const cleanTitle = title?.replaceAll("_", " ");
  const lookupKey = title?.toUpperCase()?.replace(/\s/g, "_");
  const iconSrc = iconMap[lookupKey] || iconMap[title?.toUpperCase()];

  /* 🔹 Get modal params dynamically */
  const chartParams = chartParamMap[lookupKey] || {
    Partner_Type: [],
    Service_Type: [],
  };

  const modalParams = {
    ...chartParams,
    ...modalPayload,
  };

  /* COLORS */

  const colors = ["#7C83FD", "#00C49F", "#FF9F43", "#FF6B6B"];

  /* Repeat Automatically */
  const chartColor = colors[colorPointer % colors.length];
  colorPointer++;

  /* MONTH ORDER */
  const categories = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const values = categories.map((m) => data?.[m] ?? null);
  const isPercentage = title?.includes("%");

  const options = {
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        const p = params[0];
        return `${p.name}: <span style="font-weight:bold">${format(p.value, isPercentage)}</span>`;
      },
    },

    grid: {
      top: "25%",
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },

    xAxis: {
      type: "category",
      data: categories,
      boundaryGap: false,

      axisLine: { show: false },
      axisTick: { show: false },

      axisLabel: {
        fontSize: 10,
        color: "#666",
      },

      splitLine: { show: false },
    },

    yAxis: {
      type: "value",
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },
      splitLine: { show: false },
    },

    series: [
      {
        type: "line",
        data: values,
        smooth: true,

        symbol: "circle",
        symbolSize: 7,

        // 🔹 Data labels on top of points
        label: {
          show: true,
          position: "top",
          rotate: 90,
          distance: 10,
          verticalAlign: "middle",
          align: "left",
          fontSize: 10,
          fontWeight: "bold",
          color: chartColor,
          formatter: (params) => format(params.value, isPercentage),
        },

        // Line color
        lineStyle: {
          width: 2,
          color: chartColor,
        },

        // Marker style
        itemStyle: {
          color: "#fff",
          borderColor: chartColor,
          borderWidth: 2,
        },

        // Gradient area
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: chartColor + "99" },
              { offset: 1, color: chartColor + "08" },
            ],
          },
        },
      },
    ],
  };

  return (
    <>
      <div
        data-pdf-chart
        className="relative bg-white border border-gray-200 rounded-xl p-2 shadow-sm"
      >
        {/* 🔹 Title with dynamic icon */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 font-semibold text-[#505050] mb-2">
            {iconSrc && <img src={iconSrc} alt="icon" className=" " />}
            {cleanTitle}
          </div>

          <IoOpenOutline
            className="text-[#197BC2] cursor-pointer"
            title={`${cleanTitle} details`} // 👈 dynamic hover text
            onClick={() => setIsModalOpen(true)}
          />
        </div>

        {/* KPI CARDS */}
        <div className="absolute top-10 right-0 flex gap-8 w-full px-2">
          <KpiCard title="TARGET" value={format(target, isPercentage)} />
          <KpiCard
            title={previousYear?.label || ""}
            value={format(previousYear?.value, isPercentage)}
          />
          <KpiCard
            title={ytdActual?.label?.replace(/_/g, " ") || "YTD"}
            value={format(
              ytdActual?.label ? ytdActual?.value : ytdActual,
              isPercentage,
            )}
          />
        </div>

        <div className="mt-16">
          <ReactECharts option={options} style={{ height: 180 }} />
        </div>

        {isModalOpen && (
          <ServiceCollabaxModal
            closeModal={() => setIsModalOpen(false)}
            modalParams={modalParams}
            endpoint={modalEndpoint}
            Heading={cleanTitle}
          />
        )}
      </div>
    </>
  );
}

/* =====================================================
   HELPERS
===================================================== */

const format = (val, isPercentage) => {
  if (val === null || val === undefined || val === "") return "-";

  // If already includes %, don't add another one
  if (typeof val === "string" && val.includes("%")) return val;

  const num = Number(val);
  if (isNaN(num)) return val;

  let res = "";
  if (num >= 10000000) res = (num / 10000000).toFixed(1) + " Cr";
  else if (num >= 100000) res = (num / 100000).toFixed(1) + " L";
  else if (num >= 1000) res = (num / 1000).toFixed(1) + " K";
  else {
    res = num.toLocaleString("en-IN", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
  }

  return isPercentage ? `${res}%` : res;
};

const KpiCard = ({ title, value }) => (
  <div className="px-3 py-1 bg-white border rounded-lg shadow text-center w-[95px]">
    <div className="text-[10px] uppercase text-gray-400 font-semibold">
      {title}
    </div>
    <div className="font-bold text-[#595959] whitespace-nowrap">{value}</div>
  </div>
);
